import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragListStatus: 'idle',
    loadAuftragListError: undefined as any,
    loadAuftragListLastArgs: undefined as any,
    loadAuftragStatus: 'idle',
    loadAuftragError: undefined as any,

    auftragList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragList = createAsyncThunk('toAuftragSlice/loadAuftragList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toAuftragSlice.loadAuftragListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftrag/?action=gte&TOID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragListStatus } = getState().toAuftragSlice
        return loadAuftragListStatus !== 'pending'
    }
})

export const loadAuftrag = createAsyncThunk('toAuftragSlice/loadAuftrag', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftrag/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragStatus } = getState().toAuftragSlice
        return loadAuftragStatus !== 'pending'
    }
})

const AuftragSlice = createSlice({
    name: 'toAuftragSlice',
    initialState,
    reducers: {
        resetloadAuftragListError: (state) => {
            state.loadAuftragListError = undefined
        },
        resetloadAuftrag: (state) => {
            state.formItem = undefined
            state.loadAuftragError = undefined
        },
        resetloadAuftragError: (state) => {
            state.loadAuftragError = undefined
        },
        removeFromAuftragListById: (state, action) => {
            state.auftragList = state.auftragList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragListByIds: (state, action) => {
            state.auftragList = state.auftragList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragListStatus = 'preloaded'
            state.loadAuftragListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragList = []
            state.loadAuftragListStatus = 'idle'
            state.loadAuftragListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragList.pending, (state) => {
            state.loadAuftragListStatus = 'pending'
            state.loadAuftragListError = undefined
        })
        builder.addCase(loadAuftragList.fulfilled, (state, action) => {
            state.loadAuftragListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragListLastArgs = action.payload.args

            {
                state.auftragList = action.payload.data

            }
        })
        builder.addCase(loadAuftragList.rejected, (state, action) => {
            state.loadAuftragListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragListError = action.error.message
            } else {
                state.loadAuftragListError = action.payload
            }
        })

        builder.addCase(loadAuftrag.pending, (state) => {
            state.loadAuftragStatus = 'pending'
            state.loadAuftragError = undefined
        })
        builder.addCase(loadAuftrag.fulfilled, (state, action) => {
            state.loadAuftragStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragList.push(newItem) }
                else { state.auftragList[i] = { ...state.auftragList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftrag.rejected, (state, action) => {
            state.loadAuftragStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragError = action.error.message
            } else {
                state.loadAuftragError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragListError,
    resetloadAuftrag,
    resetloadAuftragError,
    removeFromAuftragListById,
    removeFromAuftragListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragSlice.actions
export default AuftragSlice.reducer
